import { IsEncumbranceRealtyContainer } from '../../containers/advancedFilters/IsEncumbranceRealtyContainer/IsEncumbranceRealtyContainer';
import { IFilter } from '../../types/advancedFilters';

export const isEncumbranceRealty: IFilter = {
  component: IsEncumbranceRealtyContainer,
};
